import { memo } from 'react';
import styled from 'styled-components';

export const sizeMap = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '60px',
};

const SVGComponent = styled.svg`
  color: ${({ $color }) => $color};
`;

export const BaseIcon = memo((props) => {
  const { svg, size = 'medium', color = 'inherit', ...others } = props;
  const domSize = sizeMap[size] ?? size;
  return (
    <SVGComponent
      as={svg}
      width={domSize}
      height={domSize}
      $color={color}
      {...others}
    />
  );
});
